import { Constants } from '../constants.js';

export function createShareURL(config) {
  return Constants.share.url + '?order=' + config.roomOrder + 'z8z' + config.name + 'z8z' + config.com + 'z8z' + config.skin;
}

